import { render } from "./DividendsBanner.vue?vue&type=template&id=23271ecc"
import script from "./DividendsBanner.vue?vue&type=script&lang=js"
export * from "./DividendsBanner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__